export default {
    list: {
        title: 'Sady vstupenek',
        empty: 'Žádné sady vstupenek',
        cols: {
            name: 'Jméno',
            event: 'Událost',
            entries: 'Vstupů',
            entryPause: 'Min mezi',
            validate: 'Hláška',
            tickets: 'Vstupenek'
        },
        viewTickets: 'Zobrazit vstupenky'
    },
    filter: {
        search: 'Hledat',
        event: 'Událost'
    },
    form: {
        name: 'Jméno',
        customName: 'Hláška při kontrole',
        validate: 'Aktivovat hlášku při kontrole',
        section: {
            edit: 'Editovat',
            metadata: 'Metadata',
            prices: 'Cenové hladiny'
        }
    },
    metadata: {
        event: 'Událost',
        prefix: 'Prefix',
        entries: 'Vstupů',
        entryPause: 'Min mezi vstupy',
        unlimited: 'Neomezeno',
        bzucoId: 'Bzuco ID',
        yes: 'Ano',
        no: 'Ne'
    },
    prices: {
        cols: {
            name: 'Jméno',
            title: 'Text na vstupence',
            people: 'Osob',
            price: 'Cena',
            currency: 'Měna'
        },
        empty: 'Žádné cenové hladiny'
    },
    bzucoSynced: {
        badge: 'Synced',
        tooltip: 'Synchronizováno z externího systému'
    },
    confirm: {
        unsavedChanges: 'Máte neuložené změny. Opravdu zavřít?'
    },
    toast: {
        saved: 'Sada uložena'
    },
    qr: {
        title: 'Konfigurační QR kód',
        addToClipboard: 'Přidat do schránky',
        added: 'Přidáno do schránky'
    }
}
